module.exports = __webpack_public_path__ + "static/aleksy_rafalowicz-59a176025338663f84236b6540a3f4e0.png";